import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerMachineryAllocation } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerMachineryAllocationSlice = createSlice({
  name: "ProjectManagerMachineryAllocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerMachineryAllocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerMachineryAllocation.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerMachineryAllocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Project Manager Machinery Allocation  List";
      });
  },
});

export default ProjectManagerMachineryAllocationSlice.reducer;
